module.exports = __webpack_public_path__ + "static/media/telegram_full.7017aad231ca01efc30b9b3c0849181c.svg";